import { BottomSheet } from "@Light/components/page/BottomSheet";
import clsx from "clsx";
import React from "react";

export type EnrollBottomSheetProps = {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  "data-testid"?: string;
};

export const EnrollBottomSheet: React.FC<EnrollBottomSheetProps> = ({
  open,
  onClose,
  title,
  subtitle,
  footer,
  children,
  ...props
}) => {
  return (
    <BottomSheet open={open} onClose={onClose}>
      <div className="flex flex-col px-4 pt-4 pb-6" {...props}>
        <div className={clsx("flex flex-col gap-0.5", children && "pb-5")}>
          <h2 className="text-lg font-semibold text-primary leading-7 pr-10 text-balance">
            {title}
          </h2>
          {subtitle ? (
            <p className="text-sm text-tertiary leading-5">{subtitle}</p>
          ) : null}
        </div>
        {children}
        {footer ? <div className="pt-6">{footer}</div> : null}
      </div>
    </BottomSheet>
  );
};
